import type { CheckoutCommonReduxState } from "@app/types/checkout-v2-types";
import type { ResultsReduxState } from "@app/types/results-redux-types";

export const getTripLegsByTripId = (
  state: CheckoutCommonReduxState | ResultsReduxState,
  trip_id: string
) => {
  // @ts-expect-error TS2532 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
  return state.trips[trip_id].trip_legs;
};
